import React from 'reactn';
import autoBind from 'react-autobind';
import LoginScreen from './login';
import BookList from './BookList';
import Book from './Book';

export default class App extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    if(!this.global.auth) {
      return <LoginScreen onLogin={token => this.dispatch.onLogin(token)}/>
    }
    if(window.location.pathname.length > 1) {
      const nick = window.location.pathname.substring(1);
      return <Book nick={nick} />
    }
    // if(this.global.bookLoaded === 0) {
    //   const style= {
    //     "padding": '1rem', "borderRadius": '1rem', "background": '#eee',
    //     "cursor": "pointer", "margin": "1rem", "textAlign": "center", "width":'90%',
    //     "display": "inline-block", "border":"1px solid #555"
    //   };
    //   return <div style={{"textAlign":"center"}}>{
    //     this.global.bookList.map(({book,he,ru}) => <div key={book} style={style}  onClick={()=>this.dispatch.loadBook(book)}>{he} | {ru}</div>)
    //   }</div>
    // }
    //return <Book id={this.global.bookLoaded} />
    return <BookList />
  }
};

